
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shape-of-you",
      function () {
        return require("private-next-pages/shape-of-you.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shape-of-you"])
      });
    }
  